<template>
  <div :class="noStyle ? '' : 'flex flex-col gap-1'">
    <!-- Label rendered only if not hidden -->
    <label
        v-if="label && !hideLabel"
        class="block text-h5 font-normal font-archivo text-primary"
    >
      {{ label }}
    </label>

    <!-- Input wrapper for prefix/suffix -->
    <div
        v-if="!textarea"
        :class="[
        'relative',
        prefix || suffix ? 'flex items-center' : ''
      ]"
    >
      <span
          v-if="prefix"
          :class="[
          'absolute left-3 pl-3 text-paragraph',
          model ? 'text-primary' : 'text-tertiary-dark',
          disabled ? 'opacity-50' : ''
        ]"
      >
        {{ prefix }}
      </span>

      <!-- Input -->
      <input
          :type="type"
          :placeholder="placeholder"
          :value="model"
          @input="e => model = (e.target as HTMLInputElement).value"
          :disabled="disabled"
          :class="[
          'w-full',
          noStyle
            ? 'px-3 py-2 text-paragraph'
            : 'px-3 py-2 text-paragraph font-normal border rounded-md',
          'focus:outline-hidden focus:border-tertiary',
          model ? 'text-primary' : 'text-tertiary-dark',
          'placeholder-tertiary-dark',
          prefix ? 'pl-8' : '',
          suffix ? 'pr-12' : ''
        ]"
      />

      <span
          v-if="suffix"
          :class="[
          'absolute right-0 pr-3 text-paragraph',
          model ? 'text-primary' : 'text-tertiary-dark',
          disabled ? 'opacity-50' : ''
        ]"
      >
        {{ suffix }}
      </span>
    </div>

    <textarea
        v-else
        :rows="rows"
        :placeholder="placeholder"
        :value="model"
        @input="e => model = (e.target as HTMLInputElement).value"
        :disabled="disabled"
        :class="[
        'w-full',
        noStyle
          ? 'px-3 py-2 text-paragraph'
          : 'px-3 py-2 text-paragraph font-normal border border-tertiary-300 rounded-md',
        'focus:outline-hidden focus:border-tertiary',
        model ? 'text-primary' : 'text-tertiary-dark'
      ]"
    />

    <h5 v-if="error" class="text-red-600 mt-2">
      {{ error }}
    </h5>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  label?: string
  type?: string
  placeholder?: string
  modelValue: string
  textarea?: boolean
  rows?: number
  noStyle?: boolean
  hideLabel?: boolean
  error?: string
  disabled?: boolean
  prefix?: string
  suffix?: string
}>(), {
  rows: 4,
  noStyle: false,
  hideLabel: false,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const model = computed({
  get: () => props.modelValue,
  set: (val: string) => emit('update:modelValue', val),
})
</script>